const initialState = {
  signIn: {}
};

const signInReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'signIn':
      return {
        ...state,
        // Full replace, not merge: merging left the previous account's fields
        // in place wherever the new payload didn't overwrite them.
        signIn: action.payload
      };
    default:
      return state;
  }
};
export default signInReducer;
